import gql from 'graphql-tag';
import { type ApolloError, useQuery } from '@apollo/react-hooks';
import { UserRole } from '../../../../../components';

const GET_APPLICATION_PANEL_REMARKS = gql`
  query ($panelId: ID!, $filter: PanelApplicationFilter) {
    getPanelApplications(panelId: $panelId, filter: $filter) {
      remarks {
        netId
        remark
        role
      }
    }
  }
`;

type GetApplicationPanelRemarks = {
  remark: string;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetApplicationPanelRemarks = (
  panelId: string,
  skip: boolean,
  filter?: any,
): GetApplicationPanelRemarks => {
  const { data, loading, error, refetch } = useQuery(
    GET_APPLICATION_PANEL_REMARKS,
    {
      variables: { panelId, filter },
      skip,
      fetchPolicy: 'network-only',
    },
  );

  const allRemarks =
    data?.getPanelApplications?.[0]?.remarks?.filter(
      (remark: any) => remark?.role === UserRole.DO_RPG_S,
    ) ?? [];

  const latestRemark =
    allRemarks.length > 0
      ? (allRemarks[allRemarks.length - 1]?.remark ?? '')
      : '';

  return {
    remark: latestRemark,
    loading,
    error,
    refetch,
  };
};
